import ClearFormButton from './ClearFormButton';

export default ClearFormButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PrivateForms/FormButtons/ClearFormButton/index.js